export default __webpack_public_path__ + "static/media/document-text.f51a0750.svg";